/** Shared greetings and sample paths across demos (personalized narrator voice). */

export const SITE_VOICE = {
  /** Main welcome line typed in demos and echoes */
  welcomePhrase: "Hello, Welcome to Hitarth's Terminal World!",
  promptPath: '~/how-terminals-work',
  /** Unix `ls -l` style "user group" column */
  lsOwnerGroup: 'hitarth staff',
  readmeHeading: "# How terminals work — Hitarth's notebook",
  sectionIntro:
    "An interactive tour — I'm Hitarth; this is how I walk people through terminals.",
  apiHello: "Hello from Hitarth's Terminal World!",
  stateMgmtSettingsPath: '~/.config/how-terminals-work/settings.json',
  stateMgmtHistoryPath: '~/.local/state/how-terminals-work/history.jsonl',
  flowLsOutputLine:
    '\x1b[34mhow-terminals-work\x1b[0m  \x1b[34mgolden-hour-exports\x1b[0m  \x1b[32mbuild.ts\x1b[0m',
  commandFlowOutputSample:
    'drwxr-xr-x  …  how-terminals-work  README.md build.ts …',
  escapePreviewPlaceholder:
    'Try the welcome banner, or riff on chai-in-Delhi…',
  keyboardEmptySubtitle: 'Same escape bytes I stare at wiring TUIs.',
  stateMgmtInteractivePlaceholder: 'Leave future-Hitarth a scratch note…',
  /** Synthetic log timestamp in TUIs demo */
  tuiDeployUpdatedAt: 'Updated: 2026-05-08 21:40 IST • New Delhi desk',
} as const;
